const carouselModule = angular.module('com.comtrade.shared.ctxCarousel', [
]);

carouselModule.component('ctxCarousel', require('./ctxCarousel.component'));
carouselModule.directive('ctxCarouselItem', require('./ctxCarouselItem.directive'));

module.exports = carouselModule;



// WEBPACK FOOTER //
// ./src/shared/ctxCarousel/ctxCarousel.module.js